<template>
  <v-dialog v-model="show" max-height="200px" persistent>
    <v-card height="100%">
      <v-layout column fill-height>
        <v-card-title>
          <span class="headline">
            <v-icon large :color="skin.primary_color" class="mr-2">info</v-icon>
            {{ $t("C2C.Title") }}
          </span>

          <v-spacer></v-spacer>
          
          <v-btn :color="skin.primary_color"  fab small icon @click="close">
            <v-icon small class="subPrimary--text">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <div v-if="this.c2c" class="c2c-container" >
          <div class="c2c" v-html="this.c2c"></div>
        </div>
        
        <v-divider></v-divider>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          
          <v-btn :color="skin.primary_color" class="subPrimary--text" depressed large @click="close">
            {{ $t("Actions.Close")  }}
          </v-btn>
        </v-card-actions>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState} from 'vuex';
export default {
  name: "CoverToCover",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    c2c:{
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      skin: state => state.settings.skin,
    }),
  },
  methods: {
    close() {
      this.$root.$emit('close-modal', 'c2c');
      this.$store.state.C2C.currentC2C = null;
    }
  },
};
</script>

<style lang="stylus" scoped>
  .c2c-container {
    flex: auto;
    text-align:center;
    overflow-y:auto;
  }
  .c2c {
    height:50%; 
    margin: 0 auto; 
    display:inline-block;
  }
</style>
